import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { TableBody as Body, Tooltip } from '@mui/material';

import { TableNoData } from '../../shared/uiComponents';
import { HeaderProperties } from '../../shared/uiComponents/Table/tableProperties';
import { CustomTableRow, RowTableCell } from '../../shared/uiComponents/Table/tableHelpers';
import { EditSvg } from '../../shared/Assets/svgIcons';
import { errorNormalizer } from '../../shared/Helpers/functions';
import Delete from '../../components/Delete';

import { DispatchProperties } from '../../redux/store';
import { deleteAdpRateMapping, getAdpRateMappings } from '../../redux/State/clientSlice/adpRateMappingSlice';
import { AdpRateMappingProperties } from '../../redux/API/ClientAPIHelpers/adpRateMapping';

export const Headers: HeaderProperties[] = [
	{ id: '1', name: 'Provider', width: '200px' },
	{ id: '2', name: 'Client', width: '200px' },
	{ id: '3', name: 'Rate ID', width: '150px' },
	{ id: '4', name: 'Actions', width: '150px' },
];

interface TableBodyProperties {
	data: AdpRateMappingProperties[];
	onEdit: (item: AdpRateMappingProperties) => void;
}

export const TableBody: FC<TableBodyProperties> = ({ data, onEdit }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const handleDelete = (row: AdpRateMappingProperties) => {
		dispatch(deleteAdpRateMapping({ id: row.id, serviceCode: Boolean(row.serviceCodeId) }))
			.then(unwrapResult)
			.then(() => {
				toast('Deleted');
				dispatch(getAdpRateMappings());
			})
			.catch(errorNormalizer);
	};

	if (!data?.length) {
		return <TableNoData spanScope={Headers.length} />;
	}

	return (
		<Body>
			{data.map((row) => (
				<CustomTableRow key={row.id}>
					<RowTableCell>{row.userFullName || row.userId}</RowTableCell>
					<RowTableCell>{row.serviceCodeName || row.clientFullName || row.clientId}</RowTableCell>
					<RowTableCell>{row.rateId}</RowTableCell>
					<RowTableCell>
						<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
							<Tooltip title="Edit">
								<div style={{ cursor: 'pointer' }} onClick={() => onEdit(row)}>
									<EditSvg />
								</div>
							</Tooltip>
							<Delete deleteHandler={() => handleDelete(row)} />
						</div>
					</RowTableCell>
				</CustomTableRow>
			))}
		</Body>
	);
};
